/*
此資料 base on API-2 的回傳
 */
const state = () => ({
    data: [],
});

const actions = {};

const getters = {};

/**
 *  儲存新安 API 來的 hccs 資料，在打 API 的時候完整回傳
 */
const mutations = {
    clear(state) {
        state.data = [];
    },
    setData(state, payload) {
        state.data = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
